// @ts-nocheck
import React from 'react';

const TONES = {
  ok: 'var(--mov-accent-ink)',
  busy: 'var(--mov-warn-ink)',
  off: 'var(--mov-ink-mute)',
  danger: 'var(--mov-danger-ink)',
};

const StatusDot = ({ tone = 'ok', children, className = '' }) => {
  const c = TONES[tone] || TONES.off;
  return (
    <span
      className={['inline-flex items-center gap-1.5 text-[12.5px]', className].join(' ')}
      style={{ color: c }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 8, height: 8, borderRadius: '50%',
          background: 'currentColor', boxShadow: '0 0 0 3px rgba(0,0,0,0.06)',
        }}
      />
      {children}
    </span>
  );
};

export default StatusDot;
